import { useCallback, useEffect, useState } from 'react';
import {
    getHistoricoMedico,
    getAlergias,
    getVacinas,
    getExames,
    getHistoricoFamiliar
} from '../../api/api';

/**
 * Hook para buscar histórico médico completo do paciente
 * @param {number} pacienteId - ID do paciente
 * @param {object} options - Opções de filtro { tipo, startDate, endDate }
 */
export function useHistoricoMedico(pacienteId, options = {}) {
    const [data, setData] = useState({
        historico: [],
        alergias: [],
        vacinas: [],
        exames: [],
        historicoFamiliar: []
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        if (!pacienteId) return;

        setIsLoading(true);
        setError(null);

        try {
            const [historicoRes, alergiasRes, vacinasRes, examesRes, familiarRes] = await Promise.all([
                getHistoricoMedico(pacienteId, options),
                getAlergias(pacienteId),
                getVacinas(pacienteId),
                getExames(pacienteId),
                getHistoricoFamiliar(pacienteId)
            ]);

            setData({
                historico: historicoRes?.data?.data || [],
                alergias: alergiasRes?.data?.data || [],
                vacinas: vacinasRes?.data?.data || [],
                exames: examesRes?.data?.data || [],
                historicoFamiliar: familiarRes?.data?.data || []
            });
        } catch (err) {
            setError(err?.response?.data?.message || err?.message || 'Erro ao carregar histórico médico.');
        } finally {
            setIsLoading(false);
        }
    }, [pacienteId, JSON.stringify(options)]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const refetch = useCallback(() => {
        fetchData();
    }, [fetchData]);

    return {
        data,
        isLoading,
        error,
        refetch
    };
}

export default useHistoricoMedico;

